import { laptopLargeMax, largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';
import { MAX_WIDTH } from '../layout/PageWrapper.style';

export const Container = styled.div`
  border-top: 1px solid ${({ theme }) => theme.keyline};
  padding-top: 30px;
  margin-top: 40px;
`;

export const Content = styled.div`
  max-width: ${MAX_WIDTH - 20}px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-column-gap: 20px;
  grid-row-gap: 30px;

  @media (${laptopLargeMax}) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (${largeTabletMax}) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 0 15px;
  }

  @media (${mobileXXLargeMax}) {
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
  }
`;

export const PropertyContent = styled(Link)`
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin-bottom: 15px;
  position: relative;

  &:hover {
    background: ${({ theme }) => theme.backgroundLighter};
  }

  @media (${mobileXXLargeMax}) {
    flex: 0 0 240px;
  }
`;

export const PropertyImage = styled.img`
  display: block;
  max-width: 100%;
`;

export const PropertyNoImage = styled.img`
  display: block;
  width: 100%;
  background-color: ${(props) => props.theme.backgroundLighter};
`;

export const TextBox = styled.div`
  flex: 1;
  padding: 15px;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;

  p {
    color: ${({ theme }) => theme.textDark};
    font-size: 17px;
  }
`;

export const AccountLogo = styled.div`
  width: 38px;
  height: 38px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

export const PriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const Badge = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1;
  background-color: ${({ theme }) => theme.green};
  color: #303036;
  font-size: 15px;
  font-weight: 600;
  text-align: center;
  padding: 2px 4px;
  border-radius: 5px;
`;
